import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { Chip } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetStatusChangedBody_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type AssetStatusChangedBody_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type AssetStatusChangedBody_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type AssetStatusChangedBody_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type AssetStatusChangedBody_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', body?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip', color?: string | null } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText' }, avatar?: { __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, url?: string | null, userName: string } | null } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null } } };

export type AssetStatusChangedBody_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type AssetStatusChangedBody_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type AssetStatusChangedBody_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded' };

export type AssetStatusChangedBody_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type AssetStatusChangedBody_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type AssetStatusChangedBody_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type AssetStatusChangedBody_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type AssetStatusChangedBody_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type AssetStatusChangedBody_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type AssetStatusChangedBody_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type AssetStatusChangedBody_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type AssetStatusChangedBody_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type AssetStatusChangedBodyFragment = AssetStatusChangedBody_NotificationGroupAccessRequestApproved_Fragment | AssetStatusChangedBody_NotificationGroupAccessRequestDenied_Fragment | AssetStatusChangedBody_NotificationGroupAccessRequestSubmitted_Fragment | AssetStatusChangedBody_NotificationGroupAssetAssignedToYou_Fragment | AssetStatusChangedBody_NotificationGroupAssetStatusChanged_Fragment | AssetStatusChangedBody_NotificationGroupCommentCreated_Fragment | AssetStatusChangedBody_NotificationGroupCommentCreatedShareAccess_Fragment | AssetStatusChangedBody_NotificationGroupFileUploaded_Fragment | AssetStatusChangedBody_NotificationGroupReplyCreated_Fragment | AssetStatusChangedBody_NotificationGroupReplyCreatedShareAccess_Fragment | AssetStatusChangedBody_NotificationGroupRequesterAccessRequestApproved_Fragment | AssetStatusChangedBody_NotificationGroupRequesterAccessRequestDenied_Fragment | AssetStatusChangedBody_NotificationGroupTranscriptCompletedSelf_Fragment | AssetStatusChangedBody_NotificationGroupTransferBatchCompleted_Fragment | AssetStatusChangedBody_NotificationGroupTransferBatchCompletedSelf_Fragment | AssetStatusChangedBody_NotificationGroupUserMentioned_Fragment | AssetStatusChangedBody_NotificationGroupUserMentionedShareAccess_Fragment;

export type AssetStatusChangedBodyContentFragment = { __typename?: 'NotificationLayout', body?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip', color?: string | null } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText' }, avatar?: { __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, url?: string | null, userName: string } | null } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null };

export const AssetStatusChangedBodyContent = /*#__PURE__*/ gql`
    fragment AssetStatusChangedBodyContent on NotificationLayout {
  body {
    ...Chip
  }
}
    ${Chip}` as unknown as DocumentNode<AssetStatusChangedBodyContentFragment, unknown>;
export const AssetStatusChangedBody = /*#__PURE__*/ gql`
    fragment AssetStatusChangedBody on NotificationGroup {
  ... on NotificationGroupAssetStatusChanged {
    content {
      layout {
        ...AssetStatusChangedBodyContent
      }
    }
  }
}
    ${AssetStatusChangedBodyContent}` as unknown as DocumentNode<AssetStatusChangedBodyFragment, unknown>;

        

        
export const useAssetStatusChangedBodyFragment = (
  input: string | Omit<UseFragmentOptions<AssetStatusChangedBodyFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AssetStatusChangedBodyFragment>({
    fragment: AssetStatusChangedBody,
    fragmentName: 'AssetStatusChangedBody',
    ...options,
  });
};
  
        
        

        
export const useAssetStatusChangedBodyContentFragment = (
  input: string | Omit<UseFragmentOptions<AssetStatusChangedBodyContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<AssetStatusChangedBodyContentFragment>({
    fragment: AssetStatusChangedBodyContent,
    fragmentName: 'AssetStatusChangedBodyContent',
    ...options,
  });
};
  
        